// src/bilesenler/Siniflar/PokemonSelector.js

import { EVOLUTION_CHAINS, getPokemonImage } from './PokemonData';

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);

const PokemonSelector = ({ isOpen, onClose, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="ct-modal-backdrop" onClick={onClose}>
        <div 
            className="ct-modal-dialog" 
            style={{ maxWidth: '900px', width: '95%', height: '85vh' }} 
            onClick={e => e.stopPropagation()}
        >
            <div className="ct-modal-header" style={{ borderBottom: '2px solid #f0f0f0', alignItems: 'center' }}>
                <h5 className="ct-modal-title" style={{ fontSize: '1.5rem', fontWeight: '800', color: '#ce3737' }}>
                    Uzay Rolünü / Aracını Seç
                </h5>
                <button 
                    type="button" 
                    onClick={onClose}
                    style={{
                        background: 'transparent', border: 'none', cursor: 'pointer',
                        color: '#999', padding: '5px', display: 'flex',
                        transition: 'color 0.2s'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.color = '#dc3545'}
                    onMouseOut={(e) => e.currentTarget.style.color = '#999'}
                    title="Kapat"
                >
                    <CloseIcon />
                </button>
            </div>

            <div className="ct-modal-body" style={{ backgroundColor: '#fdfdfd' }}>
                <div className="pokemon-grid" style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', 
                    gap: '15px',
                    padding: '10px'
                }}>
                    {EVOLUTION_CHAINS.map((chain) => {
                        const baseId = chain[0]; // Uzay Kayası, Astronot Adayı vs.
                        return (
                            <div 
                                key={baseId} 
                                className="pokemon-option-card"
                                onClick={() => { onSelect(baseId); onClose(); }}
                                style={{
                                    border: '1px solid #eee',
                                    borderRadius: '12px',
                                    padding: '10px',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    background: '#fff',
                                    transition: 'transform 0.2s, border-color 0.2s, box-shadow 0.2s',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                onMouseOver={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-3px)';
                                    e.currentTarget.style.borderColor = '#0d6efd';
                                    e.currentTarget.style.boxShadow = '0 5px 10px rgba(13, 110, 253, 0.15)';
                                }}
                                onMouseOut={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.borderColor = '#eee';
                                    e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                }}
                            >
                                <div className="pokemon-img-wrapper" style={{ height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '8px' }}>
                                    <img 
                                        src={getPokemonImage(baseId)} 
                                        alt={baseId}
                                        loading="lazy"
                                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', filter: 'drop-shadow(0 3px 3px rgba(0,0,0,0.1))' }}
                                    />
                                </div>
                                <span className="pokemon-id-badge" style={{ 
                                    fontSize: '0.75rem', color: '#555', fontWeight: 'bold', 
                                    background: '#f8f9fa', padding: '4px 8px', borderRadius: '4px',
                                    display: 'inline-block', width: '100%'
                                }}>
                                    {baseId}
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    </div>
  );
};

export default PokemonSelector;